//Importaciones
import React from 'react'
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useGetUserPropsKpi } from '../../../../hooks/services/sPrivilege/useOfPrivilege';
import AuthVerify from '../../../../components/Templates/Site/AuthVerify';
import { enum__COMPONENT_SIMPLE_COLOR_TYPE, enum__ComponentType, enum__ComponentType_InvertedEnum } from '../../../../common/Dictionaries';
import BoardList from '../../../../components/Products/sKPI/Board/BoardBox/BoardListNew';
import BoardListGrouped from '../../../../components/Products/sKPI/Board/BoardBox/BoardListNew/BoardListGrouped';
import { BOARD_AGGREGATION_WHEN_NULL, BOARD_AGRUPATION_WHEN_NULL } from '../../../../configurations/application.config';
import { getLocalStorageValue } from '../../../../common/Helpers';
import { useContext } from 'react';
import MainAppContext from '../../../../MainAppContext';
import SimpleColor from '../../../../components/Products/sKPI/Board/_ComponentTypes/INFO_FINANCIAL';
import { useSetFirstLoadSelectedContainerId } from '../../../../components/Products/sKPI/Board/BoardBox/BoardList/useOfBoardList';

function BoardComponentContent(props) {
    //Helpers
    const { t } = useTranslation();
    const { token: currentAuth } = useSelector((state) => state.auth);

    const { _boardComponentInfoRecursiveValues: boardComponentInfoRecursiveValues } = useSelector((state) => state.boardViewComponentsScope);
    const { _boardVariableDataserieValues: boardVariableDataserieValues } = useSelector((state) => state.boardViewScope);
    
    //Parametros de entrada.
    const { 
        inputParam_UserPropsKpi = null,
        inputParam_ElementId = null,
        inputParam_ContainerComponent = null,
        inputParam_ContainerComponentIndex = null,
        inputParam_BoardId = null,
        setBoardVariableDataserieValues = null,
    } = props;

    const [groupDataseriesInOneList, setGroupDataseriesInOneList] = useState(getLocalStorageValue('PARAM_COOKIE_DATASERIES_GROUPED' + inputParam_BoardId, BOARD_AGRUPATION_WHEN_NULL));
    
    const [messageConfig, setMessageConfig] = useState({ message : null, messageType : "error", showMessage : true });

    const { _listComponentTypeConfig: listComponentTypeConfig } = useSelector((state) => state.boardViewScope);
    useSetFirstLoadSelectedContainerId(inputParam_ContainerComponent.containerId, boardVariableDataserieValues !== null && boardVariableDataserieValues.length > 0 ? boardVariableDataserieValues[0].dataserieId : null, listComponentTypeConfig)
    
    const findTypeInfoFinancialEntity = (l_componentData) => {
        
        const new_item = {
            financialBreakthrough: null,
            physicalAdvance: null,
            acceleration: null
        }

        l_componentData.forEach(component => {
            if (component.item !== null && component.item.item_financiero !== null) {
                new_item.financialBreakthrough = component.item.item_financiero
                new_item.financialBreakthrough.title = component.boardComponentTitle;
                new_item.financialBreakthrough.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.BACK_COLOR
            }
            if (component.item !== null && component.item.item_fisico !== null) {
                new_item.physicalAdvance =  component.item.item_fisico
                new_item.physicalAdvance.title = component.boardComponentTitle;
                new_item.physicalAdvance.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE
            }
            if (component.item !== null && component.item.item_aceleracion !== null) {
                new_item.acceleration =  component.item.item_aceleracion
                new_item.acceleration.title = component.boardComponentTitle;
                new_item.acceleration.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.BACK_COLOR
            }
        });
        
        return new_item;
    }

    const findDSReportEntity = (dataserie, component) => {
        let flag_special = false;
        let entity = {
            item: {
                title: null,
                displayValue: 'null',
                color: 'o',
                colorType: enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE,
            },
        }
        let entity2 = {
            item: {
                title: null,
                displayValue: 'null',
                color: 'o',
                colorType: enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE,
            },
            item2: {
                title: null,
                displayValue: 'null',
                color: 'o',
                colorType: enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE,
            },
            item3: {
                title: null,
                displayValue: 'null',
                color: 'o',
                colorType: enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE,
            },
        }

        const itemVal = dataserie.l_vals.length > 0 ?  dataserie.l_vals[0] : (dataserie.l_agg_vals.length > 0 ? dataserie.l_agg_vals[0] : null);

        entity.item.title = component.htmlTitle;
        entity.item.titleAux = dataserie.variableName;
        entity.item.color = itemVal !== null ? itemVal.color : t('no-data');

        entity2.item.title = component.htmlTitle;
        entity2.item.titleAux = dataserie.variableName;
        entity2.item.color = itemVal !== null ? itemVal.color: t('no-data');
        entity2.item2.title = component.htmlTitle;
        entity2.item2.titleAux = dataserie.variableName;
        entity2.item2.color = itemVal !== null ? itemVal.color: t('no-data');
        entity2.item3.title = component.htmlTitle;
        entity2.item3.titleAux = dataserie.variableName;
        entity2.item3.color = itemVal !== null ? itemVal.color: t('no-data');

        switch (component.htmlBoardAnexoRef) {
            case "DESEMPEÑO_KPI":
                entity.item.displayValue = itemVal !== null ? itemVal.valueGoalPercent: t('no-data');
                entity.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.ICON_COLOR
                break;
            case "ESTADO_FINANCIERO":
                entity.item.displayValue = itemVal !== null ? itemVal.valueGoalPercent: t('no-data');
                entity.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.ICON_COLOR
                break;
            case "MANEJO_FTE":
                entity.item.displayValue = itemVal !== null ? itemVal.valueGoalPercent: t('no-data');
                entity.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.ICON_COLOR
                break;
            case "RECSS":
                entity.item.displayValue = `${itemVal !== null ? itemVal.displayValue: t('no-data')}${dataserie.um}`;
                entity.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.TEXT_COLOR
                break;
            case "CUMPLIMIENTO_LABORAL":
                entity.item.displayValue = `${itemVal !== null ? itemVal.displayValue: t('no-data')}${dataserie.um}`;
                entity.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.TEXT_COLOR
                break;
            case "FTE_OPEX":
                entity.item.displayValue = itemVal !== null ? itemVal.displayValue: t('no-data');
                entity.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.TEXT_COLOR
                break;
            case "EMPLEABILIDAD":
                entity.item.displayValue = `${itemVal !== null ? itemVal.valueReal: t('no-data')}${dataserie.um}`;
                entity.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.TEXT_COLOR
                break;
            case "GASTO_MES":
                entity2.item.displayValue = `${itemVal !== null ? itemVal.displayValue: t('no-data')} ${dataserie.um}`;
                entity2.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE

                entity2.item2.displayValue = `${itemVal !== null ? itemVal.valueGoal: t('no-data')} ${dataserie.um}`;
                entity2.item2.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE

                entity2.item3.displayValue =`${itemVal !== null ? Math.round(itemVal.desvPercent) : t('no-data')}%`;
                entity2.item3.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.BACK_COLOR
                flag_special = true;
                break;
            case "GASTO_YTD":
                entity2.item.displayValue = `${itemVal !== null ? itemVal.displayValue: t('no-data')} ${dataserie.um}`;
                entity2.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE

                entity2.item2.displayValue = `${itemVal !== null ? itemVal.valueGoal: t('no-data')} ${dataserie.um}`;
                entity2.item2.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE

                entity2.item3.displayValue =`${itemVal !== null ? Math.round(itemVal.desvPercent) : t('no-data')}%`;
                entity2.item3.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.BACK_COLOR
                flag_special = true;
                break;

            case "FTE_PERMANENT":
                entity2.item.displayValue = itemVal !== null ? itemVal.displayValue: t('no-data');
                entity2.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE

                entity2.item2.displayValue = itemVal !== null ? itemVal.valueGoal: t('no-data');
                entity2.item2.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE

                entity2.item3.displayValue = itemVal !== null ? itemVal.desv: t('no-data');
                entity2.item3.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.TEXT_COLOR
                flag_special = true;
                break;
            case "FTE_TEMPORAL":
                entity2.item.displayValue = itemVal !== null ? itemVal.displayValue: t('no-data');
                entity2.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE

                entity2.item2.displayValue = itemVal !== null ? itemVal.valueGoal: t('no-data');
                entity2.item2.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE

                entity2.item3.displayValue = itemVal !== null ? itemVal.desv: t('no-data');
                entity2.item3.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.TEXT_COLOR
                flag_special = true;
                break;

            case "AVAILABILITY":
                entity.item.displayValue = itemVal !== null ? itemVal.valueGoalPercent: t('no-data');
                entity.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE
                break;
            case "UTILIZATION":
                entity.item.displayValue = itemVal !== null ? itemVal.valueGoalPercent: t('no-data');
                entity.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE
                break;
            default:
                break;
        }
        
        return flag_special ? entity2 : entity;
    }

    const findDSReportField = (component) => {
        let fields = null

        switch (component.htmlBoardAnexoRef) {
            case "DESEMPEÑO_KPI":
                fields = [{usePartialTitle: false, name: 'performanceKpi', field: 'item', symbol: "%"}]
                break;
            case "ESTADO_FINANCIERO":
                fields = [{usePartialTitle: false, name: 'performanceFinancial', field: 'item', symbol: "%"}]
                break;
            case "MANEJO_FTE":
                fields = [{usePartialTitle: false, name: 'performanceFTEHandling', field: 'item', symbol: "%"}]
                break;
            case "RECSS":
                fields = [{usePartialTitle: false, name: 'recss', field: 'item', symbol: ""}]
                break;
            case "CUMPLIMIENTO_LABORAL":
                fields = [{usePartialTitle: false, name: 'laborCompliance', field: 'item', symbol: ""}]
                break;
            case "FTE_OPEX":
                fields = [{usePartialTitle: false, name: 'fteOpexPermanence', field: 'item', symbol: ""}]
                break;
            case "EMPLEABILIDAD":
                fields = [{usePartialTitle: false, name: 'employability', field: 'item', symbol: ""}]
                break;
            case "GASTO_MES":
                fields = [{usePartialTitle: true, name: 'billsMonth', field: 'item', symbol: ""},{usePartialTitle: true, name: 'budgetMonth', field: 'item2', symbol: ""},{usePartialTitle: true, name: 'accumulatedMonth', field: 'item3', symbol: ""}]
                break;
            case "GASTO_YTD":
                fields = [{usePartialTitle: true, name: 'billsYTD', field: 'item', symbol: ""},{usePartialTitle: true, name: 'budgetYTD', field: 'item2', symbol: ""},{usePartialTitle: true, name: 'accumulatedYTD', field: 'item3', symbol: ""}]
                break;

            case "FTE_PERMANENT":
                fields = [{usePartialTitle: false, name: 'fte-p-real', field: 'item', symbol: ""},{usePartialTitle: false, name: 'fte-p-ppto', field: 'item2', symbol: ""},{usePartialTitle: false, name: 'fte-p-desv', field: 'item3', symbol: ""}]
                break;
            case "FTE_TEMPORAL":
                fields = [{usePartialTitle: false, name: 'fte-t-real', field: 'item', symbol: ""},{usePartialTitle: false, name: 'fte-t-desv', field: 'item2', symbol: ""},{usePartialTitle: false, name: 'fte-t-desv', field: 'item3', symbol: ""}]
                break;

            case "AVAILABILITY":
                fields = [{usePartialTitle: false, name: 'equipment-availability', field: 'item', symbol: ""}]
                break;
            case "UTILIZATION":
                fields = [{usePartialTitle: false, name: 'equipment-availability', field: 'item', symbol: ""}]
                break;
            default:
                break;
        }
        
        return fields;
    }

    const renderComponent = (componentKey) => {
        try {
            const l_componentDataseries = boardVariableDataserieValues.filter(variableDataserie => {
                return variableDataserie.l_components.some(componentId => componentId === inputParam_ContainerComponent.id);
            });
            
            let componentData = null;
            let componentDataAndConfig = null;
            
            switch (inputParam_ContainerComponent.componentTypeId) {
                case enum__ComponentType.LIST:
                    return  <>
                                {
                                    !groupDataseriesInOneList && listComponentTypeConfig.containerId && listComponentTypeConfig.dataserieId &&
                                    <BoardList
                                        inputParam_BoardId={inputParam_BoardId}
                                        inputParam_ElementId={inputParam_ElementId}
                                        inputParam_DataserieList={l_componentDataseries}
                                        setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                                        inputParam_ContainerComponent={inputParam_ContainerComponent}
                                    />
                                }
                                {
                                    groupDataseriesInOneList &&  listComponentTypeConfig.containerId && listComponentTypeConfig.dataserieId &&
                                    <BoardListGrouped
                                        inputParam_UserPropsKpi={inputParam_UserPropsKpi}
                                        inputParam_BoardId={inputParam_BoardId}
                                        inputParam_ElementId={inputParam_ElementId}
                                        inputParam_DataserieList={l_componentDataseries}
                                        setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                                        inputParam_ContainerComponent={inputParam_ContainerComponent}
                                        inputParam_ContainerComponentIndex={inputParam_ContainerComponentIndex}
                                    />
                                }
                            </>

                case enum__ComponentType.INFO_SIMPLE_KPI:
                    componentDataAndConfig = boardComponentInfoRecursiveValues[enum__ComponentType_InvertedEnum[inputParam_ContainerComponent.componentTypeId]].find(x => x.componentConfig.id === inputParam_ContainerComponent.id);
                    componentData = findTypeInfoFinancialEntity(componentDataAndConfig.componentData, inputParam_ContainerComponent)
                    
                    return  <SimpleColor
                                inputParam_Component={null}
                                inputParam_Dataserie={null}
                                inputParam_ItemFields={[
                                    {usePartialTitle: false, name: "financialBreakthrough", field: "financialBreakthrough", symbol: "%"}, 
                                    {usePartialTitle: false, name: "physicalAdvance", field: "physicalAdvance", symbol: "%"},
                                    {usePartialTitle: false, name: "acceleration", field: "acceleration", symbol: ""}
                                ]}
                                inputParam_Item={ componentData }
                            />

                case enum__ComponentType.DS_SIMPLEDATA:
                case enum__ComponentType.DS_SIMPLEDATA_PERFORMANCE:
                    return  <SimpleColor
                                inputParam_BoardId={inputParam_BoardId}
                                inputParam_Component={inputParam_ContainerComponent}
                                inputParam_Dataserie={boardVariableDataserieValues.find(x => x.dataserieId === inputParam_ContainerComponent.dataserieId)}
                                inputParam_ItemFields={findDSReportField(inputParam_ContainerComponent)}
                                inputParam_Item={findDSReportEntity(boardVariableDataserieValues.find(x => x.dataserieId === inputParam_ContainerComponent.dataserieId), inputParam_ContainerComponent)}
                            />
                default:
                    return undefined
            }
        } catch (error) {
                
        }
    }

    //Render de componente.
    return (boardComponentInfoRecursiveValues && renderComponent(inputParam_ContainerComponent));
}

export default BoardComponentContent;